const messages = {
    profile: 'Profile',
    logout: 'Sign out',
    promocode: 'My promo code',
    title: 'Coin Hub Admin',
    auth: 'Manage authenticators',
};

export default messages;
